import get from 'transmute/get';
export const getCookieBannerOnExitVisible = get('cookieBannerOnExitVisible');